import api from '.';

export interface GetForgotPasswordParams {
  email: string;
}

export async function getForgotPassword(params: GetForgotPasswordParams) {
  const { data } = await api.get(
    `${process.env.REACT_APP_PROJECT_REGISTER_URL}/reset-password-external-users/forgot`,
    {
      params
    }
  );
  return data;
}
